var index ={
    text: "Welcome to your group chat!",
              createdAt:" ",
              time: "",
              uid: "System",
              rid: " ", 
              chatName: "",
              userList : []
    }
export default index;